// Auth is handled via custom UI + passwordless OTP (Cognito custom auth) through our API.

export type AuthState = {
  idToken: string | null;
  email: string | null;
  refreshToken: string | null;
};

const LS_TOKEN = 'silentpost.idToken';
const LS_EMAIL = 'silentpost.email';
const LS_REFRESH = 'silentpost.refreshToken';

const LEGACY_LS_TOKEN = 'afterlife.idToken';
const LEGACY_LS_EMAIL = 'afterlife.email';

function migrateLegacyKeys() {
  if (typeof window === 'undefined') return;
  const legacyToken = localStorage.getItem(LEGACY_LS_TOKEN);
  const legacyEmail = localStorage.getItem(LEGACY_LS_EMAIL);
  if (legacyToken && !localStorage.getItem(LS_TOKEN)) {
    localStorage.setItem(LS_TOKEN, legacyToken);
  }
  if (legacyEmail && !localStorage.getItem(LS_EMAIL)) {
    localStorage.setItem(LS_EMAIL, legacyEmail);
  }
  if (legacyToken) localStorage.removeItem(LEGACY_LS_TOKEN);
  if (legacyEmail) localStorage.removeItem(LEGACY_LS_EMAIL);
}

export function getAuth(): AuthState {
  migrateLegacyKeys();
  return {
    idToken: localStorage.getItem(LS_TOKEN),
    email: localStorage.getItem(LS_EMAIL),
    refreshToken: localStorage.getItem(LS_REFRESH),
  };
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(LS_REFRESH);
}

export function getIdToken(): string | null {
  return localStorage.getItem(LS_TOKEN);
}

export function setAuth(idToken: string, email: string, refreshToken?: string | null) {
  localStorage.setItem(LS_TOKEN, idToken);
  localStorage.setItem(LS_EMAIL, email);
  if (refreshToken) {
    localStorage.setItem(LS_REFRESH, refreshToken);
  }
}

export function setIdToken(idToken: string) {
  localStorage.setItem(LS_TOKEN, idToken);
}

export function clearAuth() {
  localStorage.removeItem(LS_TOKEN);
  localStorage.removeItem(LS_EMAIL);
  localStorage.removeItem(LS_REFRESH);
  localStorage.removeItem(LEGACY_LS_TOKEN);
  localStorage.removeItem(LEGACY_LS_EMAIL);
}

// sign-in is now done via /auth/otp/start + /auth/otp/verify and then setAuth().
